import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 38.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      d: "M0 0h100v38.3H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#8C0014",
      d: "M0 38.3h100V0H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFF",
      d: "M79.617 21.127v.978c0 .822.742 1.577 1.907 1.577a2.5 2.5 0 0 0 2.479-1.792l3.738-.001c-.557 1.732-2.854 3.789-7.078 3.789-5.505 0-7.231-2.982-7.231-5.261 0-2.431 1.994-5.324 7.222-5.324 4.52 0 7.222 2.62 7.222 5.325 0 .452-.038.709-.038.709zm0-1.644h2.094v-1.341c0-.405-.323-1.046-1.054-1.046-.678 0-1.04.614-1.04 1.04zm-15.339 3.628H62.79v2.098h10.055v-2.098h-1.508V12.443H62.79v2.099h1.488zm-10.359-1.984v.978c0 .822.744 1.577 1.909 1.577a2.5 2.5 0 0 0 2.478-1.792l3.739-.001c-.557 1.732-2.855 3.789-7.078 3.789-5.506 0-7.231-2.982-7.231-5.261 0-2.431 1.992-5.324 7.223-5.324 4.518 0 7.222 2.62 7.222 5.325 0 .452-.039.709-.039.709zm0-1.644h2.095v-1.341c0-.405-.323-1.046-1.054-1.046-.677 0-1.041.614-1.041 1.04zm-9.484-5.723-.973-1.852-3.072 1.584.973 1.87zm1.221 1.851h-8.26v2.099h1.506v5.401h-1.506v2.098h9.767v-2.098h-1.507zm-17.132-3.168h7.517v2.1h-1.507v8.568h1.507v2.098h-9.77v-2.098h1.508v-5.553l-5.551 7.651-5.572-7.651v5.553h1.508v2.098h-5.401v-2.098h1.489v-8.568h-1.489v-2.1h8.529l3.625 4.981z"
    }, null, -1)
  ])))
}
export default { render: render }